import { ICoreContext } from '@msdyn365-commerce/core';

export const validateField = (name: string, value: string, restrictedRegions?: string[]): string | null => {
    switch (name.toLowerCase()) {
        case 'zipcode':
            if (value.length < 5) return 'Post code is too short.';
            if (value.length > 8) return 'Post code is too long.';

            const pattern = /^([A-Za-z]{1,2}\d{1,2}[A-Za-z]?\s?\d[A-Za-z]{2})$/;
            if (!pattern.test(value)) {
                return 'Please enter a valid postcode before proceeding.';
            }

            const isRestrictedCode = restrictedRegions?.find(postCode => {
                return value.toLowerCase().startsWith(postCode.toLowerCase());
            });
            if (isRestrictedCode) {
                return 'Post code is restricted for some products.';
            }
            break;

        case 'city':
        case 'town':
            if (!value) return 'Town/city is missing.';
            if (/\d/.test(value)) return 'Town/city should not include any numbers.';
            break;

        case 'email':
            if (!value.includes('@')) return 'Email is missing the @ character.';
            if ((value.match(/@/g) || []).length > 1) return 'Email has more than one @ character.';
            if (!/\.[^@]+$/.test(value.split('@')[1] || '')) return 'Email is missing the domain i.e. .co.uk.';
            if (!/@(gmail|yahoo|hotmail|outlook|sky)\./i.test(value)) return 'Ensure the email domain is spelled correctly.';
            if (/\s/.test(value)) return 'Email must not contain spaces.';
            break;

        case 'phone':
            if (!/^\+?\d+$/.test(value)) return 'Phone number must be numeric with no special characters.';
            if (value.startsWith('+') || value.startsWith('00')) {
                return 'Remove “+” or “00” from the beginning of your phone number.';
            }
            if (value.length < 9) return 'Your phone number is too short, please provide at least 9 digits.';
            if (value.length > 11) return 'Your phone number is too long, please provide a maximum of 11 digits.';
            break;

        default:
            return null;
    }

    return null;
};

export const removeSpecialChars = (str: string, ctx: ICoreContext): string => {
    if (ctx && ctx.request.app?.config.removeSpecialCharsPDP) {
        return str?.replace(/[^a-zA-Z0-9- ]/g, '');
    }
    return str;
};
